import {createContext, useContext} from 'react';

import type {FC, ReactNode} from 'react';

export interface DiscardChangesLabels {
  title: string;
  description: string;
  keepEditingLabel: string;
  discardLabel: string;
}

const DEFAULT_LABELS: DiscardChangesLabels = {
  title: 'Leave without saving?',
  description: "The details you entered will be deleted and can't be recovered.",
  keepEditingLabel: 'Keep editing',
  discardLabel: 'Leave and delete details'
};

const DiscardChangesLabelsContext = createContext<DiscardChangesLabels>(DEFAULT_LABELS);

export interface DiscardChangesProviderProps {
  labels: DiscardChangesLabels;
  children: ReactNode;
}

/** Supplies the app's translated copy for every modal's built-in discard confirmation. */
export const DiscardChangesProvider: FC<DiscardChangesProviderProps> = ({labels, children}) => (
  <DiscardChangesLabelsContext.Provider value={labels}>
    {children}
  </DiscardChangesLabelsContext.Provider>
);

export function useDiscardChangesLabels(): DiscardChangesLabels {
  return useContext(DiscardChangesLabelsContext);
}
